<template>
  <div>
    <el-menu
      :default-active="$route.path"
      class="el-menu-vertical-demo"
      background-color="#545c64"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <MenuItem
        v-for="(route, index) in routersList"
        :key="index"
        :item="route"
        :fatherPath="route.path"
      ></MenuItem>
    </el-menu>
  </div>
</template>

<script>
import routers from "../../router/index";
import MenuItem from "./MenuItem.vue";
export default {
  components: {
    MenuItem,
  },
  data() {
    return {
      routersList: [],
    };
  },
  mounted() {
    // 获取所有定义的一级菜单和多级菜单
    // this.routersList = routers.options.routes[0].children;
    // 获取用户登录信息
    let userInfo = JSON.parse(localStorage.getItem("userinfo"));
    if(!userInfo){
      return
    }
    console.log("执行次数")
    this.routersList = routers.options.routes[0].children.map(item => {
      if(item.meta.admin && userInfo.group_id == 9 ){
        return item;
      }
      if(item.meta.qyAdmin && userInfo.group_id == 11){
        return item;
      }
      if(!item.meta.admin){
        console.log("得到的菜单项",item)
        return item
      }
    });
    
    this.routersList = this.routersList.filter(Boolean)
    let arr = JSON.parse(JSON.stringify(this.routersList[1].children));
    let arr2 = JSON.parse(JSON.stringify(this.routersList[2].children));
    arr2 = arr2.map((item) => {
      // return item
      if (item.meta.role.includes(userInfo.group_id)) {
        return item;
      }
    });
    arr = arr.map((item) => {
      // return item
      if (item.meta.role.includes(userInfo.group_id)) {
        return item;
      }
    });
    this.routersList[1].children = arr.filter(Boolean)
    console.log("arr2",arr2.length)
    if(arr2.length == 0){
      this.routersList.pop();
      // console.log("执行到了这一步",this.routersList)
    } else {
      this.routersList[2].children = arr2.filter(Boolean)
    }
  },
};
</script>

<style lang="less">
// el-menu el-menu--inline
// el-menu el-menu--inline

.child-item .el-menu-item:hover {
  background-color: #001528 !important;
}
.child-item .el-submenu__title {
  background-color: #1f2d3d !important;
}
.child-item .el-submenu__title:hover {
  background-color: #001528 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/ElMenu/index.vue